// S0: namespace riêng cho cấu hình paper trading (file chính đã 1486/1500).
export const tradingMessagesVi = {
    "widget.trading.settingsTitle": "Cài đặt Paper Trading",
    "widget.trading.commissionRate": "Phí môi giới (%)",
    "widget.trading.taxRate": "Thuế bán (%)",
    "widget.trading.slippageTicks": "Trượt giá (ticks)",
    "widget.trading.costBasisMethod": "Phương pháp giá vốn",
    "widget.trading.fifo": "FIFO (nhập trước - xuất trước)",
    "widget.trading.weightedAverage": "Bình quân gia quyền",
    "widget.trading.leverage": "Đòn bẩy tối đa",
    "widget.trading.allowShortSelling": "Cho phép bán khống",
    "widget.trading.integrityFailureMode": "Khi giao dịch gặp sự cố",
    "widget.trading.integrityMode_warn": "Chỉ cảnh báo",
    "widget.trading.integrityMode_block": "Chặn lệnh mới",
    "widget.trading.integrityMode_strict": "Từ chối im lặng",
    "widget.trading.integrityMode_warn_hint": "Vẫn cho đặt lệnh, nhưng hiện cảnh báo",
    "widget.trading.integrityMode_block_hint": "Dừng lệnh mới cho tới khi bạn xem lại sự cố",
    "widget.trading.integrityMode_strict_hint": "Xem lệnh hỏng là dữ liệu lỗi và bỏ qua, không báo",
    "widget.trading.integrityFailureModeHint": "Áp dụng khi lưu trạng thái thất bại hoặc dữ liệu giá đến không dùng được. Nó quyết định việc bạn được báo nhiều và bị khóa đến đâu — dữ liệu nền đã được bảo vệ dù chọn gì.",
    "widget.trading.persistFailedToast": "Không lưu được trạng thái giao dịch — thay đổi gần đây có thể mất khi tải lại",
    "widget.trading.barRejectedToast": "Đã bỏ qua {count} cập nhật giá không dùng được",
    "widget.trading.settlementDays": "Chu kỳ thanh toán",
    "widget.trading.perChartOverride": "Chỉ áp dụng cho riêng ô chart này",
    "widget.trading.unknownMarket": "Mã chưa được phân loại sàn — đang tạm dùng quy chuẩn VN_SPOT (Lô 100, T+2).",
    "widget.trading.openSettings": "Mở Cài đặt",
    "widget.trading.quickMode": "Chế độ nhanh (chỉ thị trường)",
    "widget.trading.position": "Vị thế",
    "widget.trading.unrealizedPnl": "Lãi/lỗ chưa thực hiện",
    "widget.trading.stopTypeHint": "Stop-market: khi giá chạm mức dừng, lệnh khớp như lệnh thị trường (stop-market). Stop-limit (giá kích hoạt + giá giới hạn) chưa được hỗ trợ.",
    "widget.trading.reviewTitle": "Xác nhận lệnh",
    "widget.trading.orderValue": "Giá trị lệnh",
    "widget.trading.pnlGross": "Gộp",
    "widget.trading.pnlNet": "Ròng",
    "widget.trading.pnlNetHint": "Ròng = đã trừ phí và trượt giá",
    "widget.trading.tabFees": "Phí",
    "widget.trading.tabExec": "Khớp lệnh",
    "widget.trading.tabPnl": "Giá vốn",
    "widget.trading.tabRules": "Quy chuẩn",
    "widget.trading.fifoShort": "FIFO",
    "widget.trading.resetDefaults": "Khôi phục mặc định",
    "widget.trading.commissionFixed": "Phí cố định (đ/HĐ)",
    "widget.trading.pnlDisplayMode": "Chế độ hiển thị PnL",
    "widget.trading.orderRejected": "Lệnh bị từ chối: {side} {quantity} {symbol} ({code})",
    // 7 mã của OrderRejectCode (src/lib/core/trading/types.ts). Trước đây
    // HistoryTab render giá trị enum THÔ cho user ("Rejected (INSUFFICIENT_BUYING_POWER)")
    // — ảnh chụp màn hình lộ chuỗi kỹ thuật, và không dịch được.
    "widget.trading.rejectCode.UNSUPPORTED_TIF": "Loại thời gian hiệu lực chưa hỗ trợ",
    "widget.trading.rejectCode.UNSUPPORTED_ORDER_TYPE": "Loại lệnh chưa hỗ trợ",
    "widget.trading.rejectCode.INSUFFICIENT_BUYING_POWER": "Không đủ sức mua",
    "widget.trading.rejectCode.INVALID_QUANTITY": "Số lượng không hợp lệ",
    "widget.trading.rejectCode.INVALID_PRICE": "Giá không hợp lệ",
    "widget.trading.rejectCode.SHORT_NOT_ALLOWED": "Không cho phép bán khống",
    "widget.trading.rejectCode.PRICE_OUT_OF_BAND": "Gá ngoài biên độ cho phép",
};
